import React, { useState, useEffect } from "react";
import Footer from "../component/Footer";
import appLogo from "../images/apps.png";
import heroImage from "../images/hero_1.jpg";
import img1 from "../images/job_logo_2.jpg";
import img from "../images/job_single_img_1.jpg";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { jobLoadSingleAction } from "../redux/actions/jobAction";
import { Link } from "react-router-dom";
import LoadingBox from "../component/LoadingBox";
import Dialog from "../component/Dialog/dialog";

function JobSingle() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const { singleJob, loading } = useSelector((state) => state.singleJob);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    window.scroll(0, 0);
    dispatch(jobLoadSingleAction(id));
  }, []);

  const alreadyApplied = user?.user?.appliedJobs.includes(singleJob?._id)
    ? true
    : false;

  const handleCloseDialog = (props) => {
    setOpen(props);
  };

  return (
    <>
      {loading && <LoadingBox />}
      {!loading && singleJob && (
        <>
          <section
            class="section-hero  inner-page"
            id="home-section"
            style={{
              backgroundColor: "rgb(64,64,64)",
            }}
          >
            <div class="container">
              <div class="row">
                <div class="col-md-7">
                  <h1
                    class="text-white"
                    style={{
                      fontSize: "4rem",
                      fontWeight: "400",
                    }}
                  >
                    Application
                  </h1>
                  <div class="custom-breadcrumbs">
                    <Link style={{ color:'white' }} to="/">
                      Home
                    </Link>{" "}
                    <span class="mx-2 slash">/</span>
                    <span class="text-white">
                      <strong>Apply</strong>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="site-section">
            <div class="container">
              <div class="row align-items-center mb-5">
                <div class="col-lg-8 mb-4 mb-lg-0">
                  <div class="d-flex align-items-center">
                    <div class="border p-2 d-inline-block mr-3 rounded">
                      <img src={img1} alt="Image" />
                    </div>
                    <div>
                      <h2>{singleJob?.position}</h2>
                      <div>
                        <span class="ml-0 mr-2 mb-2">
                          <span class="icon-briefcase mr-2"></span>
                          {singleJob?.company.name}
                        </span>
                        <span class="m-2">
                          <span class="icon-room mr-2"></span>
                          {singleJob?.jobLocation}
                        </span>
                        <span class="m-2">
                          <span class="icon-clock-o mr-2"></span>
                          <span class="">{singleJob?.jobType}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  {user?.user?.type === "user" && (
                    <div class="row">
                      <div class="col-6"></div>
                      <div class="col-6">
                        <Dialog
                          handleCloseDialog={handleCloseDialog}
                          open1={open}
                          user={user}
                          setUser={setUser}
                          singleJob={singleJob}
                        />
                        <button
                          class="btn btn-block btn-md"
                          style={{
                            backgroundColor: alreadyApplied
                              ? "grey"
                              : "#1d4ed8",
                            color: "white",
                          }}
                          onClick={() => setOpen(true)}
                          disabled={alreadyApplied}
                        >
                          {alreadyApplied ? "Applied.." : "Apply Now"}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div class="row">
                <div class="col-lg-8">
                  <div class="mb-5">
                    <figure class="mb-5">
                      <img src={img} alt="Image" class="img-fluid rounded" />
                    </figure>
                    <h3
                      class="h5 d-flex align-items-center mb-4 text-primary"
                      style={{
                        color: "#1d4ed8",
                      }}
                    >
                      <span class="icon-align-left mr-3"></span>Job Description
                    </h3>
                    <p>{singleJob?.jobDescription}</p>
                  </div>
                  <div class="mb-5">
                    <h3 class="h5 d-flex align-items-center mb-4 text-primary">
                      <span class="icon-rocket mr-3"></span>About The Role
                    </h3>
                    <ul class="list-unstyled m-0 p-0">
                      <li class="d-flex align-items-start mb-2">
                        <span class="icon-check_circle mr-2 text-muted"></span>
                        <span>Necessitatibus quibusdam facilis</span>
                      </li>
                      <li class="d-flex align-items-start mb-2">
                        <span class="icon-check_circle mr-2 text-muted"></span>
                        <span>
                          Velit unde aliquam et voluptas reiciendis n Velit unde
                          aliquam et voluptas reiciendis non sapiente labore
                        </span>
                      </li>
                      <li class="d-flex align-items-start mb-2">
                        <span class="icon-check_circle mr-2 text-muted"></span>
                        <span>Commodi quae ipsum quas est itaque</span>
                      </li>
                      <li class="d-flex align-items-start mb-2">
                        <span class="icon-check_circle mr-2 text-muted"></span>
                        <span>
                          Lorem ipsum dolor sit amet, consectetur adipisicing
                          elit
                        </span>
                      </li>
                      <li class="d-flex align-items-start mb-2">
                        <span class="icon-check_circle mr-2 text-muted"></span>
                        <span>
                          Deleniti asperiores blanditiis nihil quia officiis
                          dolor
                        </span>
                      </li>
                    </ul>
                  </div>

                  <div class="row mb-5">
                    <div class="col-6"></div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="bg-light p-3 border rounded mb-4">
                    <h3 class="text-primary  mt-3 h5 pl-3 mb-3 ">
                      Job Summary
                    </h3>
                    <ul class="list-unstyled pl-3 mb-0">
                      <li class="mb-2">
                        <strong class="text-black">Company:</strong>
                        {singleJob?.company.name}
                      </li>
                      <li class="mb-2">
                        <strong class="text-black">Published on:</strong>{" "}
                        {new Date(singleJob?.createdAt).toLocaleDateString(
                          "en-US",
                          { year: "numeric", month: "long", day: "numeric" }
                        )}
                      </li>
                      <li class="mb-2">
                        <strong class="text-black">JobType:</strong>
                        {singleJob?.jobType}
                      </li>
                      <li class="mb-2">
                        <strong class="text-black">Experience:</strong> 2 to 3
                        year(s)
                      </li>
                      <li class="mb-2">
                        <strong class="text-black">Job Location:</strong>{" "}
                        {singleJob?.jobLocation}
                      </li>
                      <li class="mb-2">
                        <strong class="text-black">Salary:</strong>
                        {singleJob?.minSalary} - {singleJob?.maxSalary} ($)
                      </li>
                    </ul>
                  </div>

                  <div class="bg-light p-3 border rounded">
                    <h3 class="text-primary  mt-3 h5 pl-3 mb-3 ">Share</h3>
                    <div class="px-3">
                      <a
                        href="#"
                        class="pt-3 pb-3 pr-3 pl-0"
                        style={{
                          color: "black",
                        }}
                      >
                        <span class="icon-facebook"></span>
                      </a>
                      <a
                        href="#"
                        class="pt-3 pb-3 pr-3 pl-0"
                        style={{
                          color: "black",
                        }}
                      >
                        <span class="icon-twitter"></span>
                      </a>
                      <a
                        href="#"
                        class="pt-3 pb-3 pr-3 pl-0"
                        style={{
                          color: "black",
                        }}
                      >
                        <span class="icon-linkedin"></span>
                      </a>
                      <a
                        href="#"
                        class="pt-3 pb-3 pr-3 pl-0"
                        style={{
                          color: "black",
                        }}
                      >
                        <span class="icon-pinterest"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section class="site-section" id="next"></section>
          <Footer />
        </>
      )}
    </>
  );
}

export default JobSingle;
